import React, { useState, useEffect } from "react";

import Header from "../components/Header";
import { cancelPayment } from "./../api/payosApi";
import Loading from "./../components/common/Loading";
import { Link, useSearchParams } from "react-router-dom";
import ToastService from "../services/ToastService";

const PayosCancel = () => {
  const [searchParams] = useSearchParams();
  const query = Object.fromEntries([...searchParams.entries()]);
  const [isLoading, setLoading] = useState(true);
  const fetchData = async () => {
    try {
      const data = await cancelPayment(query);

      if (data) {
        setLoading(false);
      }else {
        
      }
    } catch (error) {
      setLoading(false);
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Header />
      <div className="flex items-center justify-center min-h-screen bg-[#140b29] from-gray-50 to-gray-100">
        {
          isLoading ? <Loading /> :
            <>

              <div
                className="w-full max-w-2xl p-12 mx-4 text-center transition-all transform bg-white shadow-lg rounded-xl hover:shadow-xl">
                <div className="flex items-center justify-center w-24 h-24 mx-auto mb-8 bg-green-100 rounded-full">
                  <svg className="w-12 h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>

                <h1 className="mb-6 text-4xl font-extrabold text-green-600">
                  Payment Successful!
                </h1>

                <p className="mb-8 text-xl text-gray-700">
                  Thank you for your purchase.
                </p>

                {/*  <div className="p-6 mb-8 rounded-lg bg-blue-50">
            <p className="text-lg font-medium text-blue-700">
              Your tool <span className="font-bold">"http://example.com"</span> will be listed shortly.
            </p>
          </div>

          <div className="pt-8 mt-8 border-t border-gray-100">
            <p className="text-lg text-gray-700">
              Have questions? Contact us at:
            </p>
            <a href="mailto:admin@eliteai.tools"
              className="inline-block mt-2 text-xl font-medium text-blue-600 transition-colors duration-200 hover:text-blue-800">
              admin@eliteai.tools
            </a>
          </div> */}

                <div className="mt-12">
                  <Link to={'/account/mywallet'}
                    className="inline-block px-8 py-4 text-lg font-semibold text-white transition-colors duration-200 bg-green-600 rounded-lg hover:bg-green-700">
                    Return to Wallet
                  </Link>
                </div>
              </div>
            </>
        }
      </div >

    </>
  );
};

export default PayosCancel;
